Prism.languages.birb = Prism.languages.extend("clike", {
  string: {
    pattern: /r?("|')(?:\\.|(?!\1)[^\\])*\1/,
    greedy: !0
  },
  "class-name": [/\b[A-Z](?:[\d_]*[a-zA-Z]\w*)?\b/, /\b(?:[A-Z]\w*|(?!(?:var|void)\b)[a-z]\w*)(?=\s+\w+\s*[;,=()])/],
  keyword: /\b(?:assert|break|case|class|const|default|else|enum|final|follows|for|grab|if|nest|new|next|noSeeb|return|static|switch|throw|var|void|while)\b/,
  operator: /\+\+|--|&&|\|\||<<=?|>>=?|~(?:\/=?)?|[+\-*\/%&^|=!<>]=?|\?|:/,
  variable: /\b[a-z_]\w*\b/
}), Prism.languages.insertBefore("birb", "function", {
  metadata: {
    pattern: /<\w+>/,
    greedy: !0,
    alias: "symbol"
  }
});